import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost } from '../../lib/api';

export const industriesKey = () => ['catalog', 'industries'];
export const projectsKey = (industryId) => ['catalog', 'industries', industryId, 'projects'];
export const projectKey = (id) => ['catalog', 'projects', id];
export const deliverablesKey = (projectId) => ['catalog', 'projects', projectId, 'deliverables'];

export function useIndustries() {
  return useQuery({ queryKey: industriesKey(), queryFn: () => apiGet('/catalog/industries') });
}
export function useProjects(industryId) {
  return useQuery({
    queryKey: projectsKey(industryId),
    queryFn: () => apiGet(`/catalog/industries/${industryId}/projects`),
    enabled: Boolean(industryId),
  });
}
export function useProject(projectId) {
  return useQuery({
    queryKey: projectKey(projectId),
    queryFn: () => apiGet(`/catalog/projects/${projectId}`),
    enabled: Boolean(projectId),
  });
}
export function useDeliverables(projectId) {
  return useQuery({
    queryKey: deliverablesKey(projectId),
    queryFn: () => apiGet(`/catalog/projects/${projectId}/deliverables`),
    enabled: Boolean(projectId),
  });
}

/* ----------- write helpers (auto-generated codes when omitted) ---------- */
export function useCreateProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiPost('/catalog/projects', body),
    onSuccess: (proj) => {
      qc.invalidateQueries({ queryKey: projectsKey(proj.industry_id) });
      qc.invalidateQueries({ queryKey: ['auth', 'me', 'navigation'] });
    },
  });
}
export function useCreateDeliverable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiPost('/catalog/deliverables', body),
    onSuccess: (deliv) => {
      qc.invalidateQueries({ queryKey: deliverablesKey(deliv.project_id) });
      qc.invalidateQueries({ queryKey: ['auth', 'me', 'navigation'] });
    },
  });
}
